import { render, staticRenderFns } from "./RoleFormAdd.vue?vue&type=template&id=49f8504e&"
import script from "./RoleFormAdd.vue?vue&type=script&lang=js&"
export * from "./RoleFormAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports